/* eslint-disable @typescript-eslint/promise-function-async */
import restClient, { headerKey } from './restClient';
import { apiMap } from '../utilities';

const loginService = {
  login: (data: any) => {
    return restClient.makePostRequest(apiMap.login, data);
  },

  verifyOtp: (data: any) => {
    return restClient.makePostRequest(apiMap.verifyOtp, data);
  },

  checkWhatsappConsentStatus: (phoneNumber: any) => {
    return restClient.makePostRequest(apiMap.checkConsentStatus(phoneNumber), null);
  },

  whatsappOptIn: (data: any) => {
    return restClient.makePostRequest(apiMap.whatsappOptIn, data);
  },

  whatsappOptOut: (data: any) => {
    return restClient.makePostRequest(apiMap.whatsappOptOut, data);
  },

  logout: (token: string) => {
    restClient.setHeader(headerKey.AccessToken, String(token));
    return restClient.makeDeleteRequest(apiMap.logout(token));
  },
};

export default loginService;